import { useCallback } from "react";

const useProjectChange = ({
  api,
  taskId,
  setTask,
  task,
  setShowProjectDropdown,
}) => {
  return useCallback(
    async (projectId) => {
      if (!projectId) return;

      try {
        await api.task.updateTask(taskId, {
          project_id: projectId,
          version: task.version,
        });
        const updatedTask = await api.task.getTaskById(taskId);
        setTask(updatedTask);
      } catch (error) {
        console.error("Error updating task project:", error);
      } finally {
        setShowProjectDropdown?.(false);
      }
    },
    [api, taskId, setTask, task, setShowProjectDropdown]
  );
};

export default useProjectChange;
